import { createSlice } from "@reduxjs/toolkit";
import {
  loginUser,
  addNewGame,
  getGame,
  deleteGame,
  saveGame,
  registrationUser,
  loadVideoScene,
  loadSceneImage,
  saveGameSettings,
  saveTrainerQuestions,
  saveKnowledgeBaseItems,
  ensureKnowledgeBase,
  addKnowledgeBaseTopic,
  loadTrainerVideo,
  loadTrainerImage,
  loadKbVideo,
  loadKbImage,
  getGamesData,
  validateToken,
  deleteAccaunt,
  resetPassword,
  sendNewUserData,
  // confirmBirthday,
  // confirmEmailUser,
  // confirmCodeEmail,
  // getUsersForModerator,
  // getGamesForModerator,
  // postNews,
  getLinks,
  getProfile,
  changePassword,
} from "../asyncThunk/userActions";

const initialState = {
  auth: {
    isAuthenticated: !!localStorage.getItem("token"),
    isLoading: false,
    error: null,
  },
  status: null,
  actionStatus: null,
  data: null,
  profile: null,
  messages: [],
  selectedGameId: null,
  showDialog: {
    isOpen: null,
    type: null,
    data: null,
  },
  game: null,
  games: null,
  gamesLinks: [],
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    exitHandle: (state) => {
      state.auth = {
        isAuthenticated: false,
        isLoading: false,
        error: null,
      };
      state.status = null;
      state.data = null;
      state.profile = null;
      state.messages = [];
      state.selectedGameId = null;
      state.showDialog = {
        isOpen: null,
        type: null,
        data: null,
      };
      state.game = null;
      state.games = null;
      state.rules = [];
      state.info = [];
      state.gamesLinks = [];
      state.users = [];
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
    },
    clearMessages: (state) => {
      state.messages = [];
    },
    addMessage: (state, action) => {
      state.messages = [...state.messages, action.payload];
    },
    selectProject: (state, action) => {
      state.selectedGameId = action.payload;
    },
    resetSelectedProject: (state) => {
      state.selectedGameId = null;
      state.game = null;
      state.showDialog = {
        isOpen: false,
        type: null,
        data: null,
      };
    },
    closeDialog: (state) => {
      state.showDialog = {
        isOpen: false,
        type: null,
        data: null,
      };
    },
    showDialog: (state, action) => {
      const payload = action.payload;
      if (typeof payload === "string") {
        state.showDialog = { isOpen: true, type: payload, data: null };
      } else {
        state.showDialog = {
          isOpen: true,
          type: payload.type,
          data: payload.data ?? null,
        };
      }
    },
    setPreferredMessenger: (state, action) => {
      if (state.profile) {
        state.profile.preferredMessenger = action.payload;
      }
    },
    addNode: (state, action) => {
      if (!state.game) return;
      const { data } = action.payload;
      state.game.nodes = [...(state.game.nodes ?? []), ...data];
    },
    addEdges: (state, action) => {
      const { data } = action.payload;
      state.game.edges = [...state.game.edges, ...data];
    },
  },
  extraReducers: (build) => {
    build.addCase(getGamesData.pending, (state) => {
      state.status = "loading";
      state.games = null;
    });
    build.addCase(getGamesData.fulfilled, (state, action) => {
      state.status = null;
      state.gamesLinks = action.payload.map((el) => {
        return {
          _id: el._id,
          title: el.title,
        };
      });
      state.games = [...action.payload];
    });
    build.addCase(getGamesData.rejected, (state) => {
      state.status = null;
    });
    build.addCase(addNewGame.fulfilled, (state, action) => {
      state.actionStatus = null;

      if (action.payload?.type === "error") {
        state.messages = [...state.messages, { ...action.payload }];
      }
      state.showDialog = {
        isOpen: false,
        type: null,
      };
      if (action.payload?.createdId) {
        state.selectedGameId = action.payload.createdId;
      }
      if (Array.isArray(action.payload?.games)) {
        state.games = action.payload.games;
      } else if (Array.isArray(action.payload)) {
        state.games = action.payload;
      }
    });
    build.addCase(addNewGame.pending, (state) => {
      state.actionStatus = "loading";
    });
    build.addCase(addNewGame.rejected, (state, action) => {
      state.messages = [...state.messages, action.payload];
    });
    build.addCase(getGame.fulfilled, (state, action) => {
      const { game } = action.payload;
      state.status = null;
      state.game = game;
    });
    build.addCase(getGame.pending, (state) => {
      state.status = "loading";
    });
    build.addCase(getGame.rejected, (state) => {
      state.status = null;
    });
    build.addCase(saveGame.fulfilled, (state, action) => {
      state.game = action.payload;
    });
    build.addCase(deleteGame.pending, (state) => {
      state.actionStatus = "loading";
    });
    build.addCase(deleteGame.fulfilled, (state, action) => {
      state.messages = [...state.messages, action.payload];
      state.showDialog = {
        isOpen: false,
        type: null,
      };
      state.actionStatus = null;
      state.game = null;
      state.selectedGameId = null;
    });
    build.addCase(deleteGame.rejected, (state, action) => {
      state.messages = [...state.messages, action.payload];
      state.actionStatus = null;
    });
    build.addCase(loginUser.fulfilled, (state, action) => {
      if (action.payload.type === "error") {
        state.messages = [action.payload];
      } else {
        state.status = null;
        state.auth = {
          token: action.payload.token,
          isAuthenticated: true,
        };
        state.data = action.payload.user;
        localStorage.setItem("token", action.payload.token);
        localStorage.setItem("rememberUser", true);
      }
    });
    build.addCase(loginUser.rejected, (state, action) => {
      state.messages = [
        action.payload || {
          type: "error",
          message: "Не удалось выполнить вход. Попробуйте позже.",
        },
      ];
    });
    build.addCase(registrationUser.fulfilled, (state, action) => {
      state.messages = [action.payload];
    });
    build.addCase(registrationUser.rejected, (state, action) => {
      state.messages = [
        action.payload || {
          type: "error",
          message: "Не удалось завершить регистрацию. Попробуйте позже.",
        },
      ];
    });
    build.addCase(resetPassword.fulfilled, (state, action) => {
      state.messages = [action.payload];
    });
    build.addCase(resetPassword.rejected, (state, action) => {
      state.messages = [
        action.payload || {
          type: "error",
          message: "Не удалось отправить ссылку. Попробуйте позже.",
        },
      ];
    });
    build.addCase(sendNewUserData.fulfilled, (state, action) => {
      state.messages = [action.payload];
    });
    build.addCase(sendNewUserData.rejected, (state, action) => {
      state.messages = [
        action.payload || {
          type: "error",
          message: "Не удалось сохранить пароль. Попробуйте позже.",
        },
      ];
    });
    build.addCase(loadVideoScene.fulfilled, (state, action) => {
      state.game = action.payload;
      state.actionStatus = null;
    });
    build.addCase(loadVideoScene.pending, (state, action) => {
      state.actionStatus = "loading";
    });
    build.addCase(loadVideoScene.rejected, (state, action) => {
      state.actionStatus = null;
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось загрузить видео",
        },
      ];
    });
    build.addCase(loadTrainerVideo.fulfilled, (state, action) => {
      state.game = action.payload;
      state.actionStatus = null;
    });
    build.addCase(loadTrainerVideo.rejected, (state, action) => {
      state.actionStatus = null;
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось загрузить видео",
        },
      ];
    });
    build.addCase(loadKbVideo.fulfilled, (state, action) => {
      state.game = action.payload;
      state.actionStatus = null;
    });
    build.addCase(loadKbVideo.rejected, (state, action) => {
      state.actionStatus = null;
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось загрузить видео",
        },
      ];
    });
    build.addCase(loadSceneImage.fulfilled, (state, action) => {
      state.game = action.payload;
      state.actionStatus = null;
    });
    build.addCase(loadSceneImage.rejected, (state, action) => {
      state.actionStatus = null;
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось загрузить картинку",
        },
      ];
    });
    build.addCase(loadTrainerImage.fulfilled, (state, action) => {
      state.game = action.payload;
      state.actionStatus = null;
    });
    build.addCase(loadTrainerImage.rejected, (state, action) => {
      state.actionStatus = null;
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось загрузить картинку",
        },
      ];
    });
    build.addCase(loadKbImage.fulfilled, (state, action) => {
      state.game = action.payload;
      state.actionStatus = null;
    });
    build.addCase(loadKbImage.rejected, (state, action) => {
      state.actionStatus = null;
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось загрузить картинку",
        },
      ];
    });
    build.addCase(saveTrainerQuestions.fulfilled, (state, action) => {
      state.game = action.payload;
    });
    build.addCase(saveKnowledgeBaseItems.fulfilled, (state, action) => {
      const updatedGame = action.payload;
      if (!updatedGame?._id) return;

      if (state.game?._id === updatedGame._id) {
        state.game = updatedGame;
      }

      if (Array.isArray(state.games)) {
        state.games = state.games.map((game) =>
          game._id === updatedGame._id ? { ...game, ...updatedGame } : game,
        );
      }
    });
    build.addCase(ensureKnowledgeBase.fulfilled, (state, action) => {
      const updatedGame = action.payload?.game;
      if (!updatedGame?._id) return;

      state.game = updatedGame;
      const exists = state.games?.some((game) => game._id === updatedGame._id);
      if (Array.isArray(state.games)) {
        state.games = exists
          ? state.games.map((game) =>
              game._id === updatedGame._id ? { ...game, ...updatedGame } : game,
            )
          : [...state.games, updatedGame];
      } else {
        state.games = [updatedGame];
      }
    });
    build.addCase(ensureKnowledgeBase.rejected, (state, action) => {
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось открыть базу знаний",
        },
      ];
    });
    build.addCase(addKnowledgeBaseTopic.fulfilled, (state, action) => {
      const updatedGame = action.payload?.game;
      if (!updatedGame?._id) return;

      if (state.game?._id === updatedGame._id) {
        state.game = updatedGame;
      }

      if (Array.isArray(state.games)) {
        state.games = state.games.map((game) =>
          game._id === updatedGame._id ? { ...game, ...updatedGame } : game,
        );
      }
    });
    build.addCase(addKnowledgeBaseTopic.rejected, (state, action) => {
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось добавить тему",
        },
      ];
    });
    build.addCase(saveGameSettings.fulfilled, (state, action) => {
      state.game = action.payload;
      state.messages = [
        ...state.messages,
        {
          type: "info",
          message: "Изменения сохранены",
        },
      ];
    });
    build.addCase(saveGameSettings.rejected, (state, action) => {
      state.messages = [
        ...state.messages,
        action.payload || {
          type: "error",
          message: "Не удалось сохранить настройки",
        },
      ];
    });
    build.addCase(getLinks.fulfilled, (state, action) => {
      state.gamesLinks = action.payload;
    });
    build.addCase(getProfile.fulfilled, (state, action) => {
      const { user } = action.payload;

      state.status = null;
      state.profile = {
        login: user.login,
        type: user.type,
        createdAt: user.createdAt,
        email: user.email,
        limit: user.limit,
        businessSubscription: user.businessSubscription ?? null,
        subscription: user.subscription ?? null,
        preferredMessenger: user.preferredMessenger ?? "telegram",
        mediaStorage: user.mediaStorage ?? { addonBytes: 0 },
        storage: user.storage ?? null,
        tgId: user.tgId,
        accessAdultContent: user.accessAdultContent,
        birthday: user.birthday,
        payments: user.payments ?? [],
      };
      state.games = user.games;
    });
    build.addCase(changePassword.fulfilled, (state, action) => {
      state.messages = [
        ...state.messages,
        {
          type: action.payload?.type ?? "info",
          message: action.payload?.message ?? "Пароль изменён",
        },
      ];
    });
    build.addCase(changePassword.rejected, (state, action) => {
      state.messages = [
        ...state.messages,
        {
          type: action.payload?.type ?? "error",
          message:
            action.payload?.message ??
            "Не удалось изменить пароль. Попробуйте позже.",
        },
      ];
    });
    build.addCase(validateToken.pending, (state) => {
      state.auth.isLoading = true;
      state.auth.error = null;
    });
    build.addCase(validateToken.fulfilled, (state, action) => {
      state.auth.isLoading = false;
      state.auth.isAuthenticated = true;
      state.data = action.payload.user;
      localStorage.setItem("userData", JSON.stringify(action.payload.user));
    });
    build.addCase(validateToken.rejected, (state) => {
      state.auth.isLoading = false;
      state.auth.isAuthenticated = false;
      state.data = null;
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
    });
    build.addCase(deleteAccaunt.fulfilled, (state) => {
      state.auth = {
        isAuthenticated: false,
        isLoading: false,
        error: null,
      };
      state.status = null;
      state.actionStatus = null;
      state.data = null;
      state.profile = null;
      state.messages = [];
      state.selectedGameId = null;
      state.game = null;
      state.games = null;
      state.gamesLinks = null;
      state.showDialog = {
        isOpen: null,
        type: null,
      };

      localStorage.removeItem("token");
      localStorage.removeItem("userData");
    });
    // build.addCase(confirmBirthday.fulfilled, (state, action) => {
    //   state.data = action.payload;
    // });
    // build.addCase(confirmEmailUser.fulfilled, (state, action) => {
    //   state.data = action.payload;
    // });
    // build.addCase(confirmCodeEmail.fulfilled, (state, action) => {
    //   state.data = action.payload;
    // });
    // build.addCase(getGamesForModerator.fulfilled, (state, action) => {
    //   state.games = action.payload;
    // });
    // build.addCase(getUsersForModerator.fulfilled, (state, action) => {
    //   state.users = action.payload;
    // });
    // build.addCase(postNews.fulfilled, (state, action) => {
    //   state.info = action.payload;
    // });
  },
});

export const userSlice = slice.actions;
export default slice.reducer;
